import {getSafely} from 'shared/web';

import {ApiEnumItem} from '../../../types/ApiEnum';
import {KeyNameEntity} from '../../../types/KeyNameEntity';
import {FiltersType} from '../types/FiltersType';
import {readAuctionTypeFilter} from './readAuctionTypeFilter';
import {readCarStatusFilter} from './readCarStatusFilter';

export type OldFiltersType = Omit<
  FiltersType,
  'make' | 'model' | 'selectedColors' | 'auctionType' | 'carStatus'
> & {
  auctionType?: string[];
  carStatus?: string[];
  make?: {[key: string]: boolean} | string[];
  model?: {[key: string]: boolean} | string[];
  selectedColors?: (KeyNameEntity & {colorCode?: string})[];
};

const isOldMakeFormat = (
  value: {[key: string]: boolean} | string[] | undefined
): value is {[key: string]: boolean} =>
  value !== undefined && !Array.isArray(value) && typeof value === 'object' && value !== null;

const convertObjectToArray = (obj: {[key: string]: boolean}): string[] =>
  Object.keys(obj).filter((key) => getSafely(obj, key) === true);

const isOldColorFormat = (
  value: (ApiEnumItem | (KeyNameEntity & {colorCode?: string}))[] | undefined
): value is (KeyNameEntity & {colorCode?: string})[] =>
  value !== undefined &&
  Array.isArray(value) &&
  value.every((item) => 'key' in item && 'name' in item && 'colorCode' in item);

export const migrateFiltersFromOldStructure = (
  filters: OldFiltersType | FiltersType
): FiltersType => {
  const migratedFilters = {
    ...filters,
    auctionType: readAuctionTypeFilter(filters).auctionType,
    carStatus: readCarStatusFilter(filters).carStatus,
  };

  if (isOldMakeFormat(migratedFilters.make)) {
    migratedFilters.make = convertObjectToArray(migratedFilters.make);
  }

  if (isOldMakeFormat(migratedFilters.model)) {
    migratedFilters.model = convertObjectToArray(migratedFilters.model);
  }

  if (isOldColorFormat(migratedFilters.selectedColors)) {
    migratedFilters.selectedColors = migratedFilters.selectedColors.map((color) => ({
      key: color.key,
      value: color.key,
      label: color.name,
      colorCode: color.colorCode,
    }));
  }

  return migratedFilters as FiltersType;
};
